// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__OBz8t","loading":"Loading_loading__16J7O","spin":"Loading_spin__MAzfR","rotate":"Loading_rotate__YloX8","rotateccw":"Loading_rotateccw__VR9zH"};